import Vue from 'vue'
import { Form, Checkbox, Select, Input, Button, DatePicker, LocaleProvider, message, Modal, Tooltip, Icon, Alert, Spin, Cascader, Upload, Popover, Tabs } from 'ant-design-vue'
import Cart from '@/components/cart'
import ImgCaptcha from '@/components/imgcaptcha'
import '../usercoupon/config'

Vue.config.productionTip = false
Vue.use(Form)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Input)
Vue.use(Button)
Vue.use(DatePicker)
Vue.use(LocaleProvider)
Vue.use(Cart)
Vue.use(ImgCaptcha)
Vue.use(Modal)
Vue.use(Tooltip)
Vue.use(Icon)
Vue.use(Alert)
Vue.use(Spin)
Vue.use(Cascader)
Vue.use(Upload)
Vue.use(Popover)
Vue.use(Tabs)
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$error = Modal.error
Vue.prototype.$info = Modal.info
Vue.prototype.$message = message
